import { contactCard } from './contactCard';

export const attorneyContactCard = contactCard(
  'additionalContacts.attorney',
  'attorney',
);
